"use strict";
/**
 * Every venue's cached positions in one read: the primary and its parallel
 * legs (ai/POSITION_CACHE_PLAN.md §5). Breadcrumb: POST /positions →
 * src/server/routes/positions.ts.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchPositions = fetchPositions;
const request_1 = require("./request");
/** One answer per query, in request order. */
async function fetchPositions(markets) {
    const response = await (0, request_1.apiRequest)("POST", "/positions", { body: { markets } });
    return response.positions;
}
